import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './listing-detail.css'

const ListingDetail = (props) => {
  return (
    <div className="listing-detail-container1">
      <Helmet>
        <title>Listing-Detail - BidWally</title>
        <meta
          property="og:title"
          content="Listing-Detail - BidWally"
        />
        <link
          rel="canonical"
          href="https://bidwally.com/listing-detail"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="listing-detail-page">
        <section className="hero-header">
          <div className="hero-header__media">
            <img
              src="https://images.pexels.com/photos/5409749/pexels-photo-5409749.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Santa Cruz Hightower CC Mountain Bike"
              className="hero-header__bg"
            />
            <div className="hero-header__overlay"></div>
          </div>
          <div className="hero-header__container">
            <div className="hero-header__content">
              <div className="hero-header__meta">
                <span className="hero-header__category">
                  Vehicles &amp; Sports
                </span>
                <div className="hero-header__location">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <span>Vancouver, BC (North Shore)</span>
                </div>
              </div>
              <h1 className="hero-title">
                Santa Cruz Hightower CC - X01 AXS Build
              </h1>
              <div className="hero-header__pricing">
                <div className="hero-header__crypto">
                  <span className="hero-header__amount">0.125 BTC</span>
                  <span className="hero-header__label">Crypto Price</span>
                </div>
                <div className="hero-header__fiat-toggle">
                  <span className="hero-header__fiat-val">≈ $8,450.00 USD</span>
                  <button
                    aria-label="Toggle fiat reference"
                    className="hero-header__toggle-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m11 19l-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12m-6-6.236V12m3 3v6m3-3h-6M9 3.236v15"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="hero-header__actions">
                <button className="btn btn-primary btn-lg">
                  Contact Seller
                </button>
                <div className="hero-header__utility-btns">
                  <button
                    title="Save to Watchlist"
                    className="btn btn-lg btn-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                    </svg>
                    <span>Save</span>
                  </button>
                  <button
                    title="Report Listing"
                    className="btn btn-lg btn-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 16h.01M12 8v4m3.312-10a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z"></path>
                    </svg>
                    <span>Report</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="media-gallery">
          <div className="media-gallery__grid">
            <div className="media-gallery__item">
              <img
                src="https://images.pexels.com/photos/13870707/pexels-photo-13870707.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Frame Detail"
                className="media-gallery__img"
              />
              <span className="media-gallery__caption">
                Full frame view - Excellent condition
              </span>
            </div>
            <div className="media-gallery__item">
              <img
                src="https://images.pexels.com/photos/18393968/pexels-photo-18393968.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Drivetrain"
                className="media-gallery__img"
              />
              <span className="media-gallery__caption">
                X01 AXS Wireless Drivetrain
              </span>
            </div>
            <div className="media-gallery__item">
              <img
                src="https://images.pexels.com/photos/10897665/pexels-photo-10897665.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Suspension"
                className="media-gallery__img"
              />
              <span className="media-gallery__caption">
                Fox Factory 36 Kashima Coat
              </span>
            </div>
            <div className="media-gallery__item">
              <img
                src="https://images.pexels.com/photos/18347929/pexels-photo-18347929.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Cockpit"
                className="media-gallery__img"
              />
              <span className="media-gallery__caption">
                Carbon handlebars and stem
              </span>
            </div>
            <div className="media-gallery__item">
              <img
                src="https://images.pexels.com/photos/30842342/pexels-photo-30842342.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Wheelset"
                className="media-gallery__img"
              />
              <span className="media-gallery__caption">
                Reserve 30 Carbon Wheels
              </span>
            </div>
            <div className="media-gallery__item media-gallery__item--map">
              <div className="media-gallery__map-preview">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"></path>
                </svg>
                <span className="section-subtitle">View Location</span>
              </div>
            </div>
          </div>
        </section>
        <section className="listing-detail-listing-info">
          <div className="listing-info__container">
            <h2 className="section-title">Listing Specifications</h2>
            <div className="listing-info__grid">
              <div className="listing-info__card">
                <h3 className="section-subtitle">Product Details</h3>
                <ul className="listing-info__list">
                  <li className="listing-info__item">
                    <strong>Category:</strong>
                    <span> Mountain Bikes</span>
                  </li>
                  <li className="listing-info__item">
                    <strong>Condition:</strong>
                    <span> Like New (Low hours)</span>
                  </li>
                  <li className="listing-info__item">
                    <strong>Model Year:</strong>
                    <span> 2024</span>
                  </li>
                  <li className="listing-info__item">
                    <strong>Size:</strong>
                    <span> Large</span>
                  </li>
                </ul>
              </div>
              <div className="listing-info__card">
                <h3 className="section-subtitle">Technical Specs</h3>
                <p className="section-content">
                  Hightower CC carbon frame. SRAM X01 Eagle AXS electronic
                  shifting. Fox Factory Float X2 rear shock. Reserve Carbon 30
                  wheels laced to DT Swiss 350 hubs. Maxxis Minion DHF/DHR II
                  tires.
                </p>
              </div>
              <div className="listing-info__card">
                <h3 className="section-subtitle">Payment &amp; Crypto</h3>
                <div className="listing-info__crypto-tags">
                  <span className="listing-info__tag">BTC Accepted</span>
                  <span className="listing-info__tag">ETH Accepted</span>
                  <span className="listing-info__tag">USDC Preferred</span>
                </div>
                <p className="section-content">
                  Direct wallet-to-wallet transfer. Escrow roadmap coming Q4
                  2026. Non-custodial workflow recommended.
                </p>
              </div>
              <div className="listing-info__card">
                <h3 className="section-subtitle">Price History</h3>
                <div className="listing-info__history">
                  <div className="listing-info__history-row">
                    <span>Feb 12, 2026</span>
                    <strong>0.125 BTC (Current)</strong>
                  </div>
                  <div className="listing-info__history-row">
                    <span>Jan 28, 2026</span>
                    <span className="listing-info__old-price">0.132 BTC</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="trust-indicators">
          <div className="trust-indicators__container">
            <h2 className="section-title">Trust &amp; Verification</h2>
            <div className="trust-indicators__grid">
              <div className="trust-indicators__item">
                <div className="trust-indicators__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76M12 8v8m-4-4h8"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Verified Seller</h3>
                <p className="section-content">
                  Government ID and Proof of Address verified by BidWally Trust
                  Team.
                </p>
              </div>
              <div className="trust-indicators__item">
                <div className="trust-indicators__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Reputation: 98%</h3>
                <p className="section-content">
                  Highly rated based on 45 successful crypto-to-goods
                  transactions.
                </p>
              </div>
              <div className="trust-indicators__item">
                <div className="trust-indicators__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Provenance Docs</h3>
                <p className="section-content">
                  Original purchase receipt and warranty transfer documents
                  verified.
                </p>
              </div>
              <div className="trust-indicators__item">
                <div className="trust-indicators__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 8v4m0 4h.01"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Safety Tip</h3>
                <p className="section-content">
                  Always meet in a public, well-lit place. Verify the
                  transaction on-chain before departing.
                </p>
              </div>
              <div className="trust-indicators__item">
                <div className="trust-indicators__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">No Flags</h3>
                <p className="section-content">
                  This listing has zero community reports or safety warnings.
                </p>
              </div>
              <div className="trust-indicators__item">
                <div className="trust-indicators__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 7v6m-8 6.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20M9 10h6"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Buyer Guide</h3>
                <p className="section-content">
                  Read our latest guide on P2P crypto trades for high-value
                  physical goods.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="seller-profile">
          <div className="seller-profile__container">
            <div className="seller-profile__card">
              <div className="seller-profile__header">
                <div className="seller-profile__avatar">
                  <img
                    src="https://images.pexels.com/photos/13367286/pexels-photo-13367286.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Marcus Chen"
                    className="seller-profile__img"
                  />
                  <div title="Online" className="seller-profile__status"></div>
                </div>
                <div className="seller-profile__info">
                  <h3 className="section-subtitle">Marcus Chen</h3>
                  <div className="seller-profile__rating">
                    <span className="seller-profile__stars">★★★★★</span>
                    <span className="section-content">(4.9/5.0)</span>
                  </div>
                  <p className="section-content">Vancouver, BC • 5km Radius</p>
                </div>
              </div>
              <div className="seller-profile__stats">
                <div className="seller-profile__stat">
                  <strong>12</strong>
                  <span>Active Listings</span>
                </div>
                <div className="seller-profile__stat">
                  <strong>4 yrs</strong>
                  <span>Member Since</span>
                </div>
                <div className="seller-profile__stat">
                  <strong>100%</strong>
                  <span>Response Rate</span>
                </div>
              </div>
              <div className="seller-profile__actions">
                <a href="#">
                  <div className="btn btn-outline">
                    <span>View Full Profile</span>
                  </div>
                </a>
                <button className="btn btn-secondary">
                  Send Direct Message
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="location-showcase">
          <div className="location-showcase__split">
            <div className="location-showcase__map-area">
              <div className="location-showcase__map-placeholder">
                <img
                  src="https://images.pexels.com/photos/10135267/pexels-photo-10135267.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Map Area"
                  className="location-showcase__map-img"
                />
                <div className="location-showcase__pin">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
              </div>
            </div>
            <div className="location-showcase__content">
              <h2 className="section-title">Discovery &amp; Meetup</h2>
              <p className="section-content">
                Located in North Vancouver, near Lonsdale Quay. This item is
                available for local pickup or regional delivery within a 50km
                radius.
              </p>
              <div className="location-showcase__options">
                <div className="location-showcase__option">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"></path>
                  </svg>
                  <div>
                    <strong>Safe Meetup Suggestion</strong>
                    <p>
                      North Vancouver Police Station &quot;Safe Exchange
                      Zone&quot;
                    </p>
                  </div>
                </div>
                <div className="location-showcase__option">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M19 8v6m3-3h-6"></path>
                  </svg>
                  <div>
                    <strong>Shipping Options</strong>
                    <p>
                      Insured freight available across Canada (extra charge)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="transaction-model">
          <div className="transaction-model__container">
            <h2 className="section-title">How Transactions Work</h2>
            <div className="transaction-model__steps">
              <div className="transaction-model__step">
                <div className="transaction-model__number">
                  <span>01</span>
                </div>
                <div className="transaction-model__text">
                  <h3 className="section-subtitle">
                    Non-Custodial Direct Trade
                  </h3>
                  <p className="section-content">
                    BidWally does not hold your funds. You negotiate directly
                    with the seller and transfer crypto from your wallet to
                    theirs upon inspection of the goods.
                  </p>
                </div>
              </div>
              <div className="transaction-model__step">
                <div className="transaction-model__number">
                  <span>02</span>
                </div>
                <div className="transaction-model__text">
                  <h3 className="section-subtitle">Safety Workflow</h3>
                  <p className="section-content">
                    Inspect the item thoroughly. Once satisfied, initiate the
                    on-chain transfer. Wait for at least 2 confirmations (for
                    BTC) or equivalent before finalizing the hand-off.
                  </p>
                </div>
              </div>
              <div className="transaction-model__step">
                <div className="transaction-model__number">
                  <span>03</span>
                </div>
                <div className="transaction-model__text">
                  <h3 className="section-subtitle">Future Escrow Roadmap</h3>
                  <p className="section-content">
                    We are building a smart-contract based escrow system.
                    Expected Q4 2026, this will allow multi-sig protection for
                    remote trades and dispute resolution.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="checkout-flow">
          <div className="checkout-flow__container">
            <h2 className="section-title">Ready to Purchase?</h2>
            <div className="checkout-flow__steps">
              <div className="checkout-flow__step">
                <div className="checkout-flow__marker">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"></path>
                    <path d="m22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7m17 9v6m-3-3h6"></path>
                  </svg>
                </div>
                <div className="checkout-flow__content">
                  <h3 className="section-subtitle">Step 1: Send an Offer</h3>
                  <div className="checkout-flow__form">
                    <input
                      type="number"
                      step="0.001"
                      placeholder="Enter Offer (BTC)"
                      className="checkout-flow__input"
                    />
                    <button className="btn btn-accent">Submit Offer</button>
                  </div>
                </div>
              </div>
              <div className="checkout-flow__step">
                <div className="checkout-flow__marker">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M19 8v6m3-3h-6"></path>
                  </svg>
                </div>
                <div className="checkout-flow__content">
                  <h3 className="section-subtitle">Step 2: Request Details</h3>
                  <p className="section-content">
                    Request the seller&apos;s public wallet address or contact
                    info to arrange a viewing.
                  </p>
                  <button className="btn btn-outline">Request Info</button>
                </div>
              </div>
              <div className="checkout-flow__step">
                <div className="checkout-flow__marker">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m9 12l2 2l4-4"></path>
                  </svg>
                </div>
                <div className="checkout-flow__content">
                  <h3 className="section-subtitle">Seller Center</h3>
                  <p className="section-content">
                    Want more eyes on your listing? Boost it to the top of
                    search results.
                  </p>
                  <button className="btn btn-primary">
                    Feature This Listing
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="listing-detail-container4">
        <div className="listing-detail-container5">
          <Script
            html={`<script defer data-name="listing-detail-logic">
(function(){
  const fiatToggleBtn = document.querySelector('.hero-header__toggle-btn');
  const fiatValue = document.querySelector('.hero-header__fiat-val');
  
  if (fiatToggleBtn) {
    fiatToggleBtn.addEventListener('click', () => {
      const isVisible = fiatValue.style.display !== 'none';
      fiatValue.style.display = isVisible ? 'none' : 'block';
    });
  }

  const galleryItems = document.querySelectorAll('.media-gallery__item');
  galleryItems.forEach(item => {
    item.addEventListener('click', () => {
      const img = item.querySelector('img');
      if (img) {
        console.log('Opening full-screen viewer for:', img.src);
      }
    });
  });

  const offerInput = document.querySelector('.checkout-flow__input');
  const offerBtn = document.querySelector('.btn-accent');
  
  if (offerBtn) {
    offerBtn.addEventListener('click', () => {
      const val = offerInput.value;
      if (val > 0) {
        alert('Offer of ' + val + ' BTC sent to Marcus Chen. You will be notified when they respond.');
      } else {
        alert('Please enter a valid BTC amount.');
      }
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ListingDetail
